module.exports = __webpack_public_path__ + "images/close.7e134eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/close.png
// module id = w/x8
// module chunks = 19